"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CustomRecaptcha = props => {
  props.field.valueField.name = props.field.valueField.name.replace('.Value', '.CaptchaValue');
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name;
  var captchaPublicKey = field.model.captchaPublicKey;
  var [captchaValue, setCaptchaValue] = (0, _react.useState)('');

  // Google Captcha Modal fired
  if (typeof window !== 'undefined') {
    if (props.errors.length > 0) {
      var numErrors = document.getElementById('formNumErrors').value;
      if (numErrors === '1' && window.readyForCaptcha === true) {
        window.grecaptcha.execute();
      }
    }
  }

  // Runs only once the component is loaded
  (0, _react.useEffect)(() => {
    var googleApiScript = document.createElement('script');
    googleApiScript.type = 'text/javascript';
    googleApiScript.src = 'https://www.google.com/recaptcha/api.js';
    googleApiScript.id = 'recaptcha-key';
    googleApiScript.async = true;
    document.head.appendChild(googleApiScript);
    var functionScript = document.createElement('script');
    functionScript.id = 'functionScript';
    functionScript.innerHTML = 'var reCaptchaCallBack = function (token) { var reCaptcha = window.reCaptchaFunc; reCaptcha(token); };';
    document.head.appendChild(functionScript);
    window.reCaptchaFunc = window.reCaptchaFunc || null;
    if (window.reCaptchaFunc === null) {
      window.reCaptchaFunc = callbackCaptcha;
    }
    return () => {
      document.head.removeChild(document.getElementById('recaptcha-key'));
      document.head.removeChild(document.getElementById('functionScript'));
      window.reCaptchaFunc = undefined;
      window.reCaptchaCallBack = undefined;
      window.readyForCaptcha = undefined;
    };
  }, []);
  var callbackCaptcha = token => {
    setCaptchaValue(token);
    var _captchaInput = document.getElementById(fieldId);
    if (_captchaInput) {
      _captchaInput.value = token;
      _captchaInput.form.dispatchEvent(new Event('submit'));
    }
  };
  (0, _react.useEffect)(() => {
    props.field.model.value = captchaValue;
  }, [captchaValue]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "g-recaptcha",
    "data-sitekey": captchaPublicKey,
    "data-callback": "reCaptchaCallBack",
    "data-size": "invisible"
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: fieldId,
    name: fieldName,
    type: "hidden",
    className: props.errors.length > 0 ? 'is-invalid' : undefined,
    value: captchaValue
  }));
};
var _default = exports.default = CustomRecaptcha;